import React from "react";
import OrderForm from "./Component/index";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { useShouldAddConvergentContext } from "providers/shouldAddConvergentProvider";
import { sendMetriks } from "Services/sendMetriks";

const OperatoryOrderPopup = (props) => {
	const { params } = useWithDefaultParams();
	const shouldAddConvergent = useShouldAddConvergentContext();

	const onClickHandler = () => {
		if (props.onlyMetriks) {
			// Metrika.getInstance().yandex.sendEvent(
			//     YANDEX_TARGETS.OPERATORY_CLICK_CONNECT,
			//     []
			// );
		} else {
			sendMetriks("OPERATORY_CLICK_CONNECT");
			let modalModel = props.modalModel;
			let promise1 = import("Layouts/modalLayout");
			promise1.then((modules) => {
				let ModalLayout = modules.default;
				modalModel.toggleModal(
					<ModalLayout
						closeModal={closeModal}
						fullCloseElement={true}
						onlyDesktopCloseElement={true}
						closeOnClickLayout={false}
						popupB={true}
						withoutClose
					>
						<OrderForm
							closeModal={closeModal}
							tariff={props.tariff}
							sendOrder={props.sendingStore.onMobileOrderOne}
							sendOrderRepeat={props.sendingStore.onMobileOrderRepeat}
							validatePhone={props.sendingStore.validatePhone}
							text={props.text}
							orderType={props.orderType}
							ApplicationModel={props.ApplicationModel}
							providerInfo={props.providerInfo}
							apiOnly={props.apiOnly}
							params={params}
							shouldAddConvergent={shouldAddConvergent}
						/>
					</ModalLayout>
				);
			});
		}
	};

	const closeModal = () => {
		let modalModel = props.modalModel;
		modalModel.toggleModal();
	};

	return (
		<div style={props.antifilter && !props.xs ? null : { width: "100%" }} onClick={onClickHandler}>
			{props.children}
		</div>
	);
};

export default OperatoryOrderPopup;
